import * as React from 'react'
import Form, { ISubmitEvent } from 'react-jsonschema-form'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { inject } from 'mobx-react'
import { Button } from 'react-bootstrap'
import {
    UIPaymentScheduleUpdateFormSchema,
    onChangePSItem,
    getPaymentScheduleUpdateFormSchema,
    EditMonth
    // PaymentScheduleTableItem 
} from '../../../Model/PaymentScheduleItemModel'
import DateTimeHelper from '../../../Helpers/DateTimeHelper'
import UserStore from '../../../Stores/UserStore'

export interface IPaymentScheduleUpdateViewProps {
    userStore?: UserStore
    localizationStore?: LocalizationStore
}

@inject('localizationStore')
@inject('userStore')
export class PaymentScheduleUpdateView extends React.Component<IPaymentScheduleUpdateViewProps> {

    uiSchema: any = UIPaymentScheduleUpdateFormSchema

    getEditMonthButton() {
        const { localizationStore, userStore } = this.props

        if (userStore!.checkSuperAdmin) {
            return (<div>
                <Button onClick={() => { EditMonth(1) }}>+1 {localizationStore!.t!('month')}</Button>
                <Button onClick={() => { EditMonth(-1) }}>-1 {localizationStore!.t!('month')}</Button>
            </div>)
        }

        return ''
    }

    render() {

        const { localizationStore, userStore } = this.props

        return (
            <div className="setting-update-view">
                <Form
                    onSubmit={(e: ISubmitEvent<any>) => {
                        onChangePSItem(DateTimeHelper.formatDateForList(`${e.formData['date']}.01.01.0001`), userStore!.checkSuperAdmin)
                    }
                    }
                    schema={getPaymentScheduleUpdateFormSchema()}
                    uiSchema={this.uiSchema}

                >
                    <div className="modalFormBtns">
                        <Button className="" type="submit">{localizationStore!.t!('Ok')}</Button>
                    </div>
                </Form>
                {this.getEditMonthButton()}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Payment/PaymentScheduleUpdateView.tsx